export default __webpack_public_path__ + "181b751a9c28b4c6b031e10050e9c9d7.png";